import React from 'react';
import gears from '../../../assets/Gears.png';
import { FollowUpResultChart } from '../followUpResultChart/FollowUpResultChart';
import { formatDateWithOrdinal } from '../../../utils/dateFormat';

export const FollowUpResultProgress: React.FC<{ CAPSession: any, metricIndex: number }> = ({ CAPSession, metricIndex }) => {
    const lastSession = CAPSession?.sessions.reduce((max: any, session: any) =>
        session.sessionNumber > max.sessionNumber ? session : max
    );

    const today = new Date();

    const lastSessionDate = lastSession?.sessionStartDate
        ? (() => {
            const [datePart] = lastSession.sessionStartDate.split(' ');
            const [month, day, year] = datePart.split('/');
            return new Date(Number(year), Number(month) - 1, Number(day));
        })()
        : null;

    const isLastSessionToday = lastSessionDate
        && lastSessionDate.getFullYear() === today.getFullYear()
        && lastSessionDate.getMonth() === today.getMonth()
        && lastSessionDate.getDate() === today.getDate();

    const showResultPoint =
        !isLastSessionToday &&
        (CAPSession?.coachingActionPlanStatusId === 2 || CAPSession?.coachingActionPlanStatusId === 3);

    return (
        <div className="metrics-score-card">
            <div style={{ fontSize: '1.25rem', padding: '0.5rem 0.5rem', color: '#3F5765' }}>
                Results - {formatDateWithOrdinal(lastSession?.sessionStartDate)}
            </div>
            <div className="metrics-scroll-wrapper mt-3">
                <div className="metrics-card-row" style={{ display: 'inline-flex', gap: '16px' }}>
                    {CAPSession?.sessions?.length > 0 ? (
                        CAPSession.sessions.map((metric: any, i: number) => {
                            return (
                                <div
                                    key={metric.sessionNumber ?? i}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <FollowUpResultChart
                                        metricTypeName={CAPSession?.metricTypeName}
                                        metric={metric}
                                        index={metricIndex}
                                        IsCurrentPerformance={false}
                                        variant={CAPSession?.scorecardCalculationRuleId === 2 ? 'tiered' : 'legacy'}
                                        min={CAPSession?.min}
                                        max={CAPSession?.max}
                                    />
                                    {i < CAPSession.sessions.length - 1 && (
                                        <i className="pi pi-arrow-circle-right" />
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-data-wrapper">
                            <div className="no-data-inner">
                                <img src={gears} alt="No Data" className="gears-img" />
                                <div className="no-data-text">
                                    No Data
                                    <br />
                                    Available
                                </div>
                            </div>
                        </div>
                    )}
                    {showResultPoint && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="pi pi-arrow-circle-right" />
                            <FollowUpResultChart
                                metricTypeName={CAPSession?.metricTypeName}
                                metric={lastSession}
                                index={metricIndex}
                                IsCurrentPerformance
                                variant={CAPSession?.scorecardCalculationRuleId === 2 ? 'tiered' : 'legacy'}
                                min={CAPSession?.min}
                                max={CAPSession?.max}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
